<template>
  <section>
    <nav
      class="mx-2 mt-1 mb-3 is-flex is-justify-content-space-between is-align-items-center"
    >
      <h3 class="has-text-info has-text-weight-bold is-size-4">
        直接拖曳即可對區塊排序
      </h3>
      <div class="buttons">
        <a class="button is-primary" @click="onReset">
          <span>{{ $t('attributes.reset') }}</span>
        </a>
        <a class="button is-primary" @click="onUpdate">
          <span>{{ $t('attributes.update') }}</span>
        </a>
      </div>
    </nav>

    <b-table
      :data="blocks"
      :loading="loading"
      :mobile-cards="false"
      narrowed
      bordered
      draggable
      @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave"
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        centered
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="type"
        :label="$t('attributes.block_name')"
        v-slot="props"
      >
        {{ GroupBlockName(props.row.type) }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.title')"
        v-slot="props"
      >
        <b-input v-model="props.row.name"></b-input>
      </b-table-column>

      <b-table-column :label="$t('attributes.status')" centered v-slot="props">
        <b-switch
          v-model="props.row.status"
          true-value="Y"
          false-value="N"
        ></b-switch>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div v-if="!loading" class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'BlockList',

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      code: this.travelGroup.code,
      blocks: [],

      draggingRow: null,
      draggingRowIndex: null
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.code = newGroup.code
      this.loadBlocksAsync(newGroup.code)
    }
  },
  mounted() {
    this.loadBlocksAsync(this.travelGroup.code)
  },
  methods: {
    async loadBlocksAsync(code) {
      try {
        this.loading = true
        const api = `${TRAVEL_GROUPS_API}/${code}/blocks`
        const res = await this.axios.get(api)
        const blocks = res.data.data

        this.blocks = blocks.sort((t1, t2) => t1.sort - t2.sort)
      } catch (e) {
        this.blocks = []

        notifyService.fetch_error('group_block', e)
      } finally {
        this.loading = false
      }
    },
    async onReset() {
      try {
        this.loading = true
        const api = `${TRAVEL_GROUPS_API}/${this.code}/blocks/reset`
        const res = await this.axios.put(api)
        const blocks = res.data.data

        this.blocks = blocks.sort((t1, t2) => t1.sort - t2.sort)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        this.blocks = []

        notifyService.update_error(e)
      } finally {
        this.loading = false
      }
    },
    async onUpdate() {
      try {
        this.loading = true
        const api = `${TRAVEL_GROUPS_API}/${this.code}/blocks`
        const res = await this.axios.put(api, this.blocks)
        const blocks = res.data.data

        this.blocks = blocks.sort((t1, t2) => t1.sort - t2.sort)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        this.blocks = []

        notifyService.update_error(e)
      } finally {
        this.loading = false
      }
    },
    dragstart(payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index

      let blocks = [...this.blocks]

      blocks.splice(this.draggingRowIndex, 1)

      blocks.splice(droppedOnRowIndex, 0, this.draggingRow)

      this.blocks = blocks.map((b, idx) => {
        return { ...b, sort: idx + 1 }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  td {
    vertical-align: middle !important;
  }
}
</style>
